import Star from "@geist-ui/react-icons/star";

export default function Reviews(p) {
  return (
    <>
      <h1
        style={{
          margin: "auto",
          marginTop: "1rem",
          color: "white",
          width: "auto",
          textAlign: "center",
          padding: "2vh 0",
        }}
      >
        Clients Say
      </h1>
      <div id="clients-slider">
        {/* <!-- <img src="./uploads/me-cool.png" alt=""> --> */}
        <div>
          <ul id="slider-list" draggable style={{ display: "none" }}>
            <li>
              <img src="./uploads/1.jpg" draggable="false" alt="" />
            </li>
            <li>
              <img src="./uploads/2.jpg" draggable="false" alt="" />
            </li>
            <li>
              <img src="./uploads/3.jpg" draggable="false" alt="" />
            </li>
            <li>
              <img src="./uploads/4.jpg" draggable="false" alt="" />
            </li>
            <li>
              <img src="./uploads/5.jpg" draggable="false" alt="" />
            </li>
          </ul>
          <ul id="slider-items">
            <li>
              <div>
                <Star />
                <Star />
                <Star />
                <Star />
                <Star />
              </div>
              <p>
                On time Delivery was done, extremely helpful .Will hired him
                again for another project.
              </p>
              <span>
                Mohamed Fazym{" "}
                <svg
                  style={{ width: "1rem" }}
                  xmlns="http://www.w3.org/2000/svg"
                  id="flag-icon-css-mv"
                  viewBox="0 0 640 480"
                >
                  <path fill="#d21034" d="M0 0h640v480H0z" />
                  <path fill="#007e3a" d="M120 120h400v240H120z" />
                  <circle cx="350" cy="240" r="80" fill="#fff" />
                  <circle cx="380" cy="240" r="80" fill="#007e3a" />
                </svg>
              </span>
            </li>
            <li>
              <div>
                <Star />
                <Star />
                <Star />
                <Star />
                <Star />
              </div>
              <p>
                Freelancer always available to answer any queries... Very
                committed to get the job done and right! Thanks!
              </p>
              <span>
                Rizwan S{" "}
                <svg
                  style={{ width: "1rem" }}
                  xmlns="http://www.w3.org/2000/svg"
                  id="flag-icon-css-gb-eng"
                  viewBox="0 0 640 480"
                >
                  <path fill="#fff" d="M0 0h640v480H0z" />
                  <path fill="#ce1124" d="M281.6 0h76.8v480h-76.8z" />
                  <path fill="#ce1124" d="M0 201.6h640v76.8H0z" />
                </svg>
              </span>
            </li>
            <li>
              <div>
                <Star />
                <Star />
                <Star />
                <Star />
                <Star />
              </div>
              <p>
                Great communication, code working pretty fast without long load
                time. Everything went pretty quickly. Hirerate 100%
              </p>
              <span>
                Damian Toczek{" "}
                <svg
                  style={{ width: "1rem" }}
                  xmlns="http://www.w3.org/2000/svg"
                  id="flag-icon-css-de"
                  viewBox="0 0 640 480"
                >
                  <path fill="#ffce00" d="M0 320h640v160H0z" />
                  <path d="M0 0h640v160H0z" />
                  <path fill="#d00" d="M0 160h640v160H0z" />
                </svg>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}
